import { Task } from './task.interface';

export interface UpdateDefaultChecklistDto {
    name: Record<string, string>;
    tasks: Task[];
    flis: string[];
}
